import React, { createContext, useState, useContext, useEffect } from 'react';

// Define default color schemes
const defaultColors = {
  primary: 'lime',
  primaryShade: '500',
  secondary: 'stone',
  secondaryShade: '900'
};

// Create the context
export const ColorContext = createContext();

// Custom hook to use color context
export const useColors = () => useContext(ColorContext);

// Color options with Tailwind classes
export const colorOptions = [
  { name: 'Azul', value: 'blue' },
  { name: 'Índigo', value: 'indigo' },
  { name: 'Púrpura', value: 'purple' },
  { name: 'Violeta', value: 'violet' },
  { name: 'Fucsia', value: 'fuchsia' },
  { name: 'Rosa', value: 'pink' },
  { name: 'Rojo', value: 'red' },
  { name: 'Naranja', value: 'orange' },
  { name: 'Ámbar', value: 'amber' },
  { name: 'Amarillo', value: 'yellow' },
  { name: 'Lima', value: 'lime' },
  { name: 'Verde', value: 'green' },
  { name: 'Esmeralda', value: 'emerald' },
  { name: 'Teal', value: 'teal' },
  { name: 'Cian', value: 'cyan' },
  { name: 'Cielo', value: 'sky' },
  { name: 'Gris', value: 'gray' },
  { name: 'Pizarra', value: 'slate' },
  { name: 'Zinc', value: 'zinc' },
  { name: 'Piedra', value: 'stone' },
];

// Provider component
export const ColorProvider = ({ children }) => {
  // Check localStorage for saved colors
  const initialColors = JSON.parse(localStorage.getItem('jambopsColors')) || defaultColors;

  const [colors, setColors] = useState(initialColors);

  // Update specific color property
  const updateColor = (colorType, newValue) => {
    setColors(prevColors => ({
      ...prevColors,
      [colorType]: newValue
    }));
  };

  // Update entire color scheme
  const setColorScheme = (primary, primaryShade, secondary, secondaryShade) => {
    const newColors = {
      primary,
      primaryShade,
      secondary,
      secondaryShade
    };
    setColors(newColors);
  };

  // Generate class names for components based on current colors
  const getClasses = (type, defaultClass = '') => {
    if (type === 'primary') {
      return `bg-${colors.primary}-${colors.primaryShade} ${defaultClass}`;
    } else if (type === 'secondary') {
      return `bg-${colors.secondary}-${colors.secondaryShade} ${defaultClass}`;
    } else if (type === 'primary-text') {
      return `text-${colors.primary}-${colors.primaryShade} ${defaultClass}`;
    } else if (type === 'secondary-text') {
      return `text-${colors.secondary}-${colors.secondaryShade} ${defaultClass}`;
    } else if (type === 'primary-border') {
      return `border-${colors.primary}-${colors.primaryShade} ${defaultClass}`;
    } else if (type === 'primary-hover') {
      const hoverShade = parseInt(colors.primaryShade) + 100;
      return `hover:bg-${colors.primary}-${hoverShade} ${defaultClass}`;
    }
    return defaultClass;
  };

  // Save to localStorage whenever colors change
  useEffect(() => {
    localStorage.setItem('jambopsColors', JSON.stringify(colors));
  }, [colors]);

  return (
    <ColorContext.Provider value={{
      colors,
      updateColor,
      setColorScheme,
      getClasses,
      colorOptions
    }}>
      {children}
    </ColorContext.Provider>
  );
};

export default ColorProvider;
